/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Floor_Data_Temperature_HelpInputs */



/**
* | output |
* | --- |
* | "Estimated temperature at the center of the room" |
*
* @param {Floor_Data_Temperature_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const floor_data_temperature_help = /** @type {((inputs?: Floor_Data_Temperature_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Floor_Data_Temperature_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Estimated temperature at the center of the room")
	return /** @type {LocalizedString} */ ("Température estimée en centre de pièce")
});